import * as Yup from 'yup';

Yup.setLocale({
  mixed: {
    required: 'Campo obrigatório',
  },
  string: {
    email: 'Preencha um e-mail válido',
    min: 'Mínimo de ${min} caracteres',
    max: 'Máximo de ${max} caracteres',
  },
});

const Schema = Yup.object().shape({
  name: Yup.string().min(3).required(),
  email: Yup.string().email().required(),
  id_city: Yup.number().required().typeError('Campo obrigatório'),
  technician: Yup.number().required().typeError('Campo obrigatório'),
  password: Yup.string().min(8).required(),
  password_confirmation: Yup.string()
    .min(8)
    .oneOf([Yup.ref('password'), null], 'As senhas não coincidem')
    .required(),
});
export default Schema;
